import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RibbonContext } from "../../services/RibbonProvider";
import SideBarMenu from "../SideBarMenu";
import IconArrowRight from "../SvgIcons/IconArrowRight";
import IconLogout from "../SvgIcons/IconLogout";
import IconMenu from "../SvgIcons/IconMenu";
import Logo from "../SvgIcons/Logo";
import LogoMobile from "../SvgIcons/LogoMobile";
import LogoOnly from "../SvgIcons/LogoOnly";
import NotificationsIcon from "../SvgIcons/NotificationsIcon";
import GlobalSearch from "./GlobalSearch";
import "./style.css";
import { useAuth } from "../../context/AuthContext";
import CallModal from "../CallModal";
import { useSocket } from "../../context/SocketContext";
import NotificationDropdown from "../../component/Notification";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";

export default function Header({
  title,
  subtitle,
  subtitlelink,
  backbtn,
  setShowSidebar,
}) {
  const { ribbonState } = useContext(RibbonContext);
  const { notify } = useSwal();
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const { logout, authUser } = useAuth();

  const [showNotifications, setShowNotifications] = useState(false);

  // 🔹 from SocketContext
  const { callData, setCallData, setIncomingCall, fetchNotification, setFetchNotification } = useSocket();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  // 🔹 Fetch notifications from API
  const fetchNotifications = async (string = "") => {
    try {
      const res = await api.post("/uinotifications", {});
      const sorted = [...res.data].sort((a, b) => b.id - a.id);
      setNotifications(sorted);

      const unreadCount = sorted.filter((n) => n.is_read === "no").length;
      if (unreadCount?.length && string) {
        notify("You have a new ticket!");
      }
      setNotificationCount(unreadCount);
    } catch (err) {
      console.error("Failed to fetch notifications", err);
    }
  };

  // Fetch once
  useEffect(() => {
    fetchNotifications();
  }, []);

  // Fetch again on dropdown open or socket-triggered updates
  useEffect(() => {
    fetchNotifications('showNotification');
  }, [showNotifications, fetchNotification]);

  // Handle call end locally
  const handleCallEnd = () => {
    setCallData(null);
    setIncomingCall({});
  };

  return (
    <header className="d-flex align-items-center justify-content-between">
      <div className="header-leftside d-flex align-items-center">
        <Link to="/dashboard" className="logo">
          <div className="logofull"><Logo /></div>
          <div className="logoonly"><LogoOnly /></div>
          <div className="mobiledevicelogo"><LogoMobile /></div>
        </Link>

        <SideBarMenu />

        <div className="header-title">
          {backbtn && (
            <Link to={backbtn} className="btn backbtnheader">
              <IconArrowRight /> <span>Back</span>
            </Link>
          )}
          {title && (
            <Link to="/dashboard" className="dashboard toplink">
              Home
            </Link>
          )}
          {subtitle && <span>/</span>}
          {subtitle &&
            (subtitlelink && subtitlelink !== "#" ? (
              <Link to={subtitlelink} className="subtitle toplink">
                {subtitle}
              </Link>
            ) : (
              <span className="subtitle withoutlink">{subtitle}</span>
            ))}
        </div>
      </div>

      <div className="header-rightside d-flex align-items-center">
        <GlobalSearch />

        {setShowSidebar && (
          <Link
            to="#"
            className="tranparenteffect notification position-relative"
            onClick={() => setShowSidebar((prev) => !prev)}
          >
            <IconMenu />
          </Link>
        )}

        <Link to="/" className="btn logout" onClick={handleLogout}>
          <IconLogout /> <span>Logout</span>
        </Link>

        <div className="tranparenteffect notification position-relative">
          <div
            className="notification-toggle"
            onClick={() => setShowNotifications((prev) => !prev)}
          >
            <NotificationsIcon />
            {notificationCount > 0 && <span className="badge">{notificationCount > 10 ? '10+' : notificationCount}</span>}
          </div>

          <NotificationDropdown
            show={showNotifications}
            setFetchNotification={setFetchNotification}
            onClose={() => setShowNotifications(false)}
            notifications={notifications}
          />
        </div>

        <Link to="/user-details" className="profile">
          <img
            src={
              authUser?.user?.Images
                ? `${process.env.REACT_APP_IMAGE_URL || ""}/upload/${authUser?.user?.Images.replace(/^\/+/, "")}`
                : `https://fastly.picsum.photos/id/90/3000/1992.jpg?hmac=v_xO0GFiGn3zpcKzWIsZ3WoSoxJuAEXukrYJUdo2S6g`
            }
            alt="profile"
          />
        </Link>
      </div>

      {callData && <CallModal callData={callData} onCallEnd={handleCallEnd} />}
    </header>
  );
}
